import classNames from 'classnames'
import React, { type FC } from 'react'
import styles from './SearchOverlay.module.scss'
import { BusinessFinder } from '~/components/BusinessFinder/BusinessFinder'
import { type SearchOverlayProps } from './SearchOverlay.interface'

export const SearchOverlay: FC<SearchOverlayProps> = ({
  show,
  className,
  title,
  typeTitle,
  categoryTitle,
  businessTypes,
  searchButton
}) => (
  <div>
    <section
      className={classNames(
        styles.container,
        className,
        {
          [styles['container--active']]: show
        }
      )}
    >
      <div className={styles.content}>
        <div className={styles['text-col']}>
          <h2 className={styles.title}>{title}</h2>
        </div>
        <div className={styles['search-col']}>
          <BusinessFinder
            typeTitle={typeTitle}
            categoryTitle={categoryTitle}
            businessTypes={businessTypes}
            showCategory
            searchButton={searchButton}
            extraStyles={{
              list: styles['business-finder-list']
            }}
          />
        </div>
      </div>
    </section>
  </div>
)
